import { render, staticRenderFns } from "./follow-store-node.vue?vue&type=template&id=36f6424d&scoped=true"
import script from "./follow-store-node.vue?vue&type=script&lang=js"
export * from "./follow-store-node.vue?vue&type=script&lang=js"
import style0 from "./follow-store-node.vue?vue&type=style&index=0&id=36f6424d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f6424d",
  null
  
)

export default component.exports